// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import sliderItem from 'vue-concise-slider'
import Axios from 'axios'
Vue.use(function(v){

  v.prototype.$request = (conf) => Axios.request();
  Axios.interceptors.request.use(function(config){

    config.withCredentials = true;

    if(/post/i.test(config.method)){
      config.transformRequest = function(data){
        if(data && data['append'] && typeof data['append'] === 'function' && data.constructor === FormData){
          config.headers['Content-Type'] = 'multipart/form-data';
          return data;
        }

        let aData = [];
        for(let i in data){
          aData.push(i+'='+data[i]);
        }
        return aData.join('&');
      }
    }

    return config;
  });
  v.prototype.$get = (url, conf) => Axios.get(url, conf);
  v.prototype.$delete = (url, conf) => Axios.delete(url, conf);
  v.prototype.$head = (url, conf) => Axios.head(url, conf);
  v.prototype.$options = (url, conf) => Axios.options(url, conf);
  v.prototype.$post = (url, data, conf) => Axios.post(url,data,conf );
  v.prototype.$put = (url, data, conf) => Axios.put(url, data, conf);
  v.prototype.$patch = (url, data, conf) => Axios.patch(url, data, conf);

});
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js